import { accountActivationRules } from "./accountActivationRules"

export const resendResetPasswordCodeRules = ({email}) => {
    let code = "";
    const rules = accountActivationRules({email, code});
    return {
        email: {
            ... rules.email
        },
    }
}